export class PrivateComponentNames {
    constructor(public stem: string) {
    }
    get selector() {
        return "nps-" + this.stem;
    }
}

class Authorization {
    static module = "authorization";
    static ssoLogoutPath = "/connect/endsession";
    static ssoAuthorizePath = "/connect/authorize";
    static clientIdParam = "client_id";
    static redirectUriParam = "redirect_uri";
    static stateParam = "state";
    static scopeParam = "scope";
    static responseTypeParam = "response_type";
    static responseType = "token";
    static ssoUnauthorizedPath = "/account/unauthorized";
}

export class Names {
    static app = new PrivateComponentNames("app");
    static applicationBar = new PrivateComponentNames("application-bar");
    static applicationBarLayout = new PrivateComponentNames("application-bar-layout");
    static contractManagement = new PrivateComponentNames("contract-management");
    static pullOutMenuLayout = new PrivateComponentNames("pull-out-menu-layout");
    static authorization = Authorization;
    static dropdown = new PrivateComponentNames("dropdown");
    static spinner = new PrivateComponentNames("spinner");
    static mainView = new PrivateComponentNames("main-view");
    static connectionSelection = new PrivateComponentNames("connection-selection");
}



// WEBPACK FOOTER //
// ./src/app/names.ts